import DAOWishlist from "@/assets/DAO/WishList";

class WishListDTO {
    toggleDiamond(id) {
        return new Promise((resolve) => {
            DAOWishlist.getDiamond(id).then(wishlistDiamondId => {
                if (wishlistDiamondId === false) {
                    DAOWishlist.add('diamonds', {
                        'date': Date.now(),
                        'id': id
                    }).then(() => {
                        resolve(true);
                    });
                } else {
                    DAOWishlist.drop('diamonds', wishlistDiamondId);
                    resolve(false);
                }
            });
        });
    }

    /*getWishList() {
        let stoneIds = {};
        DAOWishList.getAll('diamonds').then(async (result) => {
            if (typeof result === 'object' && result.length > 0) {
                console.log(result);
                for (let numericKey in result) {

                    stoneIds.value["'" + result[numericKey].id + "'"] = result[numericKey].id.replace("id_", "");
                }
            }
        })
        return stoneIds;
    }*/

    /*isDiamondInWishList(id) {
        let isOnWishList = false;
        DAOWishList.getDiamond(id).then((result) => {
            isOnWishList = (result !== false);
        });

        return isOnWishList;
    }*/
}

export default new WishListDTO();